import { MenuItem, TextField } from "@material-ui/core";
import AvatarUserDefaultIcon from "assets/avatar_user_default.png";
import DialogDragable from "components/DialogDragable";
import moment from "moment";
import ChatMessages from "pages/agent-chat-ticket/ticket/ChatMessages";
import { memo, useEffect, useMemo, useState } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { getCustomerChatHistory } from "redux/ringme-ott-sdk";

import classes from "../AgentChatTicket.module.css";
import IconChatAvatar from "./IconChatAvatar";

const FIRST_PAGE = 0;

const TicketAllHistoryDialog = ({ open, onClose }) => {
  const dispatch = useDispatch();
  const threadInfo = useSelector((state) => state.ringmeOttSdk.threadInfo);
  console.log("threadInfo", threadInfo);

  const [listChat, setListChat] = useState([]);
  const [currentChat, setCurrentChat] = useState(null);
  const [currentChatIndex, setCurrentChatIndex] = useState(null);

  const customerChatHistory = useSelector(
    (state) => state.ringmeOttSdk.customerChatHistory
  );

  const loadingCustomerChatHistory = useSelector(
    (state) => state.ringmeOttSdk.loadingCustomerChatHistory
  );
  const [page, setPage] = useState(FIRST_PAGE);
  const [size] = useState(50);
  const [chatType, setChatType] = useState("CSKH");

  const threadUsername = threadInfo?.sender?.username;

  const handleViewMore = () => {
    const newPage = page + 1;
    setPage(newPage);
    dispatch(
      getCustomerChatHistory({
        username: threadUsername,
        type: chatType,
        page: newPage,
        size,
      })
    );
  };

  const handleSelectTyle = (e) => {
    const newType = e.target.value;
    setChatType(e.target.value);
    setPage(FIRST_PAGE);
    dispatch(
      getCustomerChatHistory({
        username: threadUsername,
        type: newType,
        page: FIRST_PAGE,
        size,
      })
    );
  };

  useEffect(() => {
    if (threadUsername) {
      setPage(FIRST_PAGE);
      dispatch(
        getCustomerChatHistory({
          username: threadUsername,
          type: chatType,
          page: FIRST_PAGE,
          size,
        })
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [threadUsername]);

  useEffect(() => {
    if (customerChatHistory) {
      if (page === FIRST_PAGE && customerChatHistory.length > 0) {
        setCurrentChat(customerChatHistory[0]);
        setCurrentChatIndex(0);
        setListChat(customerChatHistory);
      } else if (page === FIRST_PAGE && customerChatHistory.length === 0) {
        setCurrentChat(null);
        setCurrentChatIndex(null);
        setListChat([]);
      } else {
        setListChat((prev) => prev.concat(customerChatHistory));
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [customerChatHistory]);

  return (
    <DialogDragable
      open={open}
      onClose={onClose}
      isLoading={loadingCustomerChatHistory}
      defaultWidth="1100px"
      enable={null}
      containerStyle={{
        overflow: "unset",
      }}
      title={
        <div className={classes.customerHistory_dialogHeader}>
          <IconChatAvatar size={50} isCustomer />

          <div className={classes.flexContainer}>
            <div className={classes.label} style={{ fontWeight: 500 }}>
              <div>{threadInfo?.sender?.fullname}</div>
              <div className={classes.flexContainer}>
                <span>{threadInfo?.sender?.phoneNumber}</span>
                <span>{threadInfo?.sender?.email}</span>
              </div>
            </div>
          </div>
        </div>
      }>
      <div className={classes.customerHistory_body}>
        <div className={classes.customerHistory_bodyLeft}>
          <div className={classes.customerHistory_selectType}>
            <span className={`${classes.label}`}>Loại bộ phận</span>
            <span>
              <TextField
                variant="outlined"
                select
                fullWidth
                value={chatType}
                onChange={handleSelectTyle}
                style={{ width: 135 }}
                InputProps={{
                  classes: {
                    input: classes.input,
                  },
                }}>
                <MenuItem value={"CSKH"} classes={{ root: classes.input }}>
                  CSKH
                </MenuItem>
                <MenuItem value={"Bưu cục"} classes={{ root: classes.input }}>
                  Bưu cục
                </MenuItem>
              </TextField>
            </span>
          </div>
          <div className={classes.customerHistory_listReceiver}>
            {listChat?.map((item, itemIndex) => (
              <CardChatInfo
                key={itemIndex}
                isActive={itemIndex === currentChatIndex}
                onClick={() => {
                  setCurrentChat(item);
                  setCurrentChatIndex(itemIndex);
                }}
                chatInfo={item}
              />
            ))}
            {listChat?.length === 0 && (
              <div className={classes.customerHistory_noResult}>
                Không có kết quả
              </div>
            )}
            {customerChatHistory?.length === size && (
              <div className={classes.customerHistory_viewMore}>
                <span role="button" onClick={handleViewMore}>
                  Xem thêm
                </span>
              </div>
            )}
          </div>
        </div>
        <div className={classes.customerHistory_bodyRight}>
          <ChatMessages chatLog={currentChat} />
        </div>
      </div>
    </DialogDragable>
  );
};

const CardChatInfo = ({ chatInfo, isActive, onClick }) => {
  const lastMessage = useMemo(() => {
    if (!chatInfo.message || !chatInfo.sender_info) return null;

    const sortedMessages = [...chatInfo.message].sort(
      (a, b) => new Date(b.created_at) - new Date(a.created_at)
    );
    return sortedMessages.find(
      (item) => item.usertype === "sender" && item.type === "text"
    );
  }, [chatInfo.sender_info, chatInfo.message]);

  return (
    <div
      className={`${classes.customerHistory_card} ${
        isActive ? classes.active : ""
      }`}
      onClick={onClick}
      role="button">
      <img
        className={classes.customerHistory_avatar}
        alt="avatar"
        src={AvatarUserDefaultIcon}
      />
      <div className={classes.customerHistory_userInfo}>
        <div className={classes.customerHistory_userName}>
          {chatInfo.receiver_info?.full_name}
        </div>
        <div className={classes.customerHistory_userDescription}>
          {lastMessage?.text}
        </div>
        <div className={classes.customerHistory_userTime}>
          {lastMessage?.created_at &&
            moment(lastMessage.created_at).format("DD-MM-YYYY HH:mm:ss")}
        </div>
      </div>
    </div>
  );
};

export default memo(TicketAllHistoryDialog);
